import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router";

const MinimizedViewAlertingExperts = ({ pathToMaximize }) => (
    <Link className="MinimizedView MinimizedView--AlertingExperts" to={pathToMaximize}>
        <div className="MinimizedView__beacon" />
        <span
            dangerouslySetInnerHTML={{
                __html: i18n.t("rtm.text.notifying_experts"),
            }}
        />
    </Link>
);

MinimizedViewAlertingExperts.propTypes = {
    pathToMaximize: PropTypes.string.isRequired,
};

export default MinimizedViewAlertingExperts;
